<template>
<div class="chapter">
<div class="inner_page">
<p class="FMTitle" id="ABBR"><a id="page_x"></a><a href="#/xhtml/contents#ABBR">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td>AB</td>
<td>Anchor Bible</td>
</tr>
<tr>
<td>ABC</td>
<td>African Bible Commentary</td>
</tr>
<tr>
<td><i>ABD</i></td>
<td><i>Anchor Bible Dictionary</i></td>
</tr>
<tr>
<td>ACNT</td>
<td>Augsburg Commentaries on the New Testament</td>
</tr>
<tr>
<td>AnBib</td>
<td>Analecta biblica</td>
</tr>
<tr>
<td>ANTC</td>
<td>Abingdon New Testament Commentaries</td>
</tr>
<tr>
<td><i>AUSS</i></td>
<td><i>Andrews University Seminary Studies</i></td>
</tr>
<tr>
<td>AYBRL</td>
<td>Anchor Yale Bible Reference Library</td>
</tr>
<tr>
<td>BAG</td>
<td>Bauer, W., W. F. Arndt, and F. W. Gingrich. <i>A Greek-English Lexicon of the New Testament and Other Early Christian Literature</i>. 4th ed. Chicago: University of Chicago Press, 1957.</td>
</tr>
<tr>
<td><i>BBR</i></td>
<td><i>Bulletin for Biblical Research</i></td>
</tr>
<tr>
<td><i>BibInt</i></td>
<td><i>Biblical Interpretation</i></td>
</tr>
<tr>
<td><i>BJRL</i></td>
<td><i>Bulletin of the John Rylands Library</i></td>
</tr>
<tr>
<td>BNTC</td>
<td>Black’s New Testament Commentaries</td>
</tr>
<tr>
<td><i>BT</i></td>
<td><i>The Bible Translator</i></td>
</tr>
<tr>
<td><i>ChBib</i></td>
<td><i>The Church’s Bible</i></td>
</tr>
<tr>
<td><i>CBQ</i></td>
<td><i>Catholic Bible Quarterly</i></td>
</tr>
<tr>
<td>CC</td>
<td>Continental Commentaries</td>
</tr>
<tr>
<td>CCR</td>
<td>Cambridge Companions to Religion</td>
</tr>
<tr>
<td>CGLP</td>
<td>Coptic Gnostic Library Project</td>
</tr>
<tr>
<td>CGTC</td>
<td>Cambridge Greek Testament Commentary</td>
</tr>
<tr>
<td><i>CH</i></td>
<td><i>Church History</i></td>
</tr>
<tr>
<td>COS</td>
<td>Church of the Saviour</td>
</tr>
<tr>
<td><i>CPR</i></td>
<td><i>Continental Philosophy Review</i></td>
</tr>
<tr>
<td><i>DPL</i></td>
<td><i>Dictionary of Paul and His Letters</i></td>
</tr>
<tr>
<td><i>DTIB</i></td>
<td><i>Dictionary for Theological Interpretation of the Bible</i>. Edited by Kevin J. Vanhoozer, Craig G. Bartholomew, Daniel J. Treier, and N. T. Wright. London: SPCK, 2005.</td>
</tr>
<tr>
<td><a id="page_xiv">EC</a></td>
<td>Epworth Commentaries</td>
</tr>
<tr>
<td><i>EQ</i></td>
<td><i>Evangelical Quarterly</i></td>
</tr>
<tr>
<td><i>ExpTim</i></td>
<td><i>Expository Times</i></td>
</tr>
<tr>
<td>FRLANT</td>
<td>Forschungen zur Religion und Literatur des Alten und Neuen Testaments</td>
</tr>
<tr>
<td>GBS</td>
<td>Guides to Biblical Scholarship</td>
</tr>
<tr>
<td>GNS</td>
<td>Good New Studies</td>
</tr>
<tr>
<td><i>HBT</i></td>
<td><i>Horizons in Biblical Theology</i></td>
</tr>
<tr>
<td>HNT</td>
<td>Handbuch zum Neuen Testament</td>
</tr>
<tr>
<td><i>HR</i></td>
<td><i>History of Religions</i></td>
</tr>
<tr>
<td><i>HTR</i></td>
<td><i>Harvard Theological Review</i></td>
</tr>
<tr>
<td>HUT</td>
<td>Hermeneutische Untersuchungen zur Theologie</td>
</tr>
<tr>
<td><i>IBS</i></td>
<td><i>Irish Biblical Studies</i></td>
</tr>
<tr>
<td>ICC</td>
<td>International Critical Commentary</td>
</tr>
<tr>
<td><i>Int</i></td>
<td><i>Interpretation</i></td>
</tr>
<tr>
<td><i>IJST</i></td>
<td><i>International Journal of Systematic Theology</i></td>
</tr>
<tr>
<td><i>JAAR</i></td>
<td><i>Journal of the American Academy of Religion</i></td>
</tr>
<tr>
<td><i>JBL</i></td>
<td><i>Journal of Biblical Literature</i></td>
</tr>
<tr>
<td><i>JHC</i></td>
<td><i>Journal of Higher Criticism</i></td>
</tr>
<tr>
<td><i>JRelS</i></td>
<td><i>Journal of Religious Studies</i></td>
</tr>
<tr>
<td><i>JSNT</i></td>
<td><i>Journal for the Study of the New Testament</i></td>
</tr>
<tr>
<td>JSNTSup</td>
<td>Supplemental Volume to Journal for the Study of the New Testament</td>
</tr>
<tr>
<td><i>JSOT</i></td>
<td><i>Journal for the Study of the Old Testament</i></td>
</tr>
<tr>
<td><i>JTI</i></td>
<td><i>Journal for Theological Interpretation</i></td>
</tr>
<tr>
<td><i>JTS</i></td>
<td><i>Journal of Theological Studies</i></td>
</tr>
<tr>
<td>KPG</td>
<td>Knox Preaching Guides</td>
</tr>
<tr>
<td>LN</td>
<td><i>Greek-English Lexicon of the New Testament: Based on Semantic Domains</i>. Edited by J. P. Louw and E. A. Nida, 2d ed. New York: United Bible Societies, 1989.</td>
</tr>
<tr>
<td>LNTS</td>
<td>Library of New Testament Studies</td>
</tr>
<tr>
<td>LOTS</td>
<td>Library of Hebrew Bible/Old Testament Studies</td>
</tr>
<tr>
<td><i>LTP</i></td>
<td><i>Laval théologique et philosophique</i></td>
</tr>
<tr>
<td>MNTC</td>
<td>Moffatt New Testament Commentary</td>
</tr>
<tr>
<td>MNTS</td>
<td>McMaster New Testament Studies</td>
</tr>
<tr>
<td>ms(s).</td>
<td>manuscript(s)</td>
</tr>
<tr>
<td>MS</td>
<td>Mediaeval Studies</td>
</tr>
<tr>
<td>MT</td>
<td>Masoretic Text</td>
</tr>
<tr>
<td>NCB</td>
<td>New Century Bible</td>
</tr>
<tr>
<td>NewCB</td>
<td>New Clarendon Bible</td>
</tr>
<tr>
<td>NIB</td>
<td>New Interpreter’s Bible</td>
</tr>
<tr>
<td>NIBC</td>
<td>New International Biblical Commentary</td>
</tr>
<tr>
<td><a id="page_xv">NICNT</a></td>
<td>New International Commentary on the New Testament</td>
</tr>
<tr>
<td>NIGTC</td>
<td>New International Greek Testament Commentary</td>
</tr>
<tr>
<td><i>NovT</i></td>
<td><i>Novum Testamentum</i></td>
</tr>
<tr>
<td>NovTSup</td>
<td>Novum Testamentum Supplements</td>
</tr>
<tr>
<td>NPNF</td>
<td>Nicene and Post-Nicene Fathers</td>
</tr>
<tr>
<td>NTC</td>
<td>New Testament in Context</td>
</tr>
<tr>
<td>NTG</td>
<td>New Testament Guides</td>
</tr>
<tr>
<td>NTL</td>
<td>New Testament Library</td>
</tr>
<tr>
<td>NTM</td>
<td>New Testament Monographs</td>
</tr>
<tr>
<td>NTOA</td>
<td>Novum Testamentum et Orbis Antiquus</td>
</tr>
<tr>
<td><i>NTS</i></td>
<td><i>New Testament Studies</i></td>
</tr>
<tr>
<td>NTT</td>
<td>New Testament Theology</td>
</tr>
<tr>
<td><i>OHS</i></td>
<td>Basil of Caesarea, <i>On the Holy Spirit</i></td>
</tr>
<tr>
<td>OTL</td>
<td>Old Testament Library</td>
</tr>
<tr>
<td><i>PE</i></td>
<td><i>Pro Ecclesia</i></td>
</tr>
<tr>
<td>PNTC</td>
<td>Penguin New Testament Commentary</td>
</tr>
<tr>
<td><i>PRSt</i></td>
<td><i>Perspectives in Religious Studies</i></td>
</tr>
<tr>
<td>PWS</td>
<td>Pietist and Wesleyan Studies</td>
</tr>
<tr>
<td><i>RB</i></td>
<td><i>Revue biblique</i></td>
</tr>
<tr>
<td><i>ResQ</i></td>
<td><i>Restoration Quarterly</i></td>
</tr>
<tr>
<td>RNT</td>
<td>Regensburger Neues Testament</td>
</tr>
<tr>
<td>SB</td>
<td>H. Strack and P. Billerbeck, <i>Kommentar zum Neuen Testament aus Talmud und Midrasch</i>. 6 vols. Munich: Beck, 1922–61.</td>
</tr>
<tr>
<td><i>SBJT</i></td>
<td><i>Southern Baptist Journal of Theology</i></td>
</tr>
<tr>
<td>SBL</td>
<td>Society of Biblical Literature</td>
</tr>
<tr>
<td>SBLDS</td>
<td>Society of Biblical Literature Dissertation Series</td>
</tr>
<tr>
<td>SBLSBS</td>
<td>Society of Biblical Literature Sources for Biblical Study</td>
</tr>
<tr>
<td>SD</td>
<td>Studies and Documents</td>
</tr>
<tr>
<td><i>SE</i></td>
<td><i>Studia evangelica</i></td>
</tr>
<tr>
<td><i>SJT</i></td>
<td><i>Scottish Journal of Theology</i></td>
</tr>
<tr>
<td>SNTSMS</td>
<td>Society for New Testament Studies Monograph Series</td>
</tr>
<tr>
<td>SNTSU</td>
<td>Studien zum Neuen Testament und seiner Umwelt</td>
</tr>
<tr>
<td>SNTW</td>
<td>Studies of the New Testament and Its World</td>
</tr>
<tr>
<td><i>St</i></td>
<td><i>Studium</i></td>
</tr>
<tr>
<td>StBL</td>
<td>Studies in Biblical Literature</td>
</tr>
<tr>
<td>StPtr</td>
<td>Studia Patristica</td>
</tr>
<tr>
<td><i>TDNT</i></td>
<td><i>Theological Dictionary of the New Testament</i>. Edited by G. Kittel and G. Friedrich. Grand Rapids: Eerdmans, 1964–76.</td>
</tr>
<tr>
<td>TNTC</td>
<td>Tyndale New Testament Commentaries</td>
</tr>
<tr>
<td><i>TrinJ</i></td>
<td><i>Trinity Journal</i></td>
</tr>
<tr>
<td>THNTC</td>
<td>Two Horizons New Testament Commentary</td>
</tr>
<tr>
<td><i>TynBul</i></td>
<td><i>Tyndale Bulletin</i></td>
</tr>
<tr>
<td><a id="page_xvi">UBSHS</a></td>
<td>United Bible Society Handbook Series</td>
</tr>
<tr>
<td><i>VC</i></td>
<td><i>Vigilae christianae</i></td>
</tr>
<tr>
<td>WBC</td>
<td>Word Biblical Commentary</td>
</tr>
<tr>
<td><i>WJF</i></td>
<td>Fletcher, John William. <i>The Works of the Rev. John Fletcher, Late Vicar of Madeley</i>. 4 vols. New York: Carlton and Lanahan, 1854.</td>
</tr>
<tr>
<td><i>WJW</i></td>
<td><i>Works of John Wesley</i>. Edited by Albert C. Outler et al. Nashville: Abingdon, 1984–.</td>
</tr>
<tr>
<td><i>WJW-Jackson</i></td>
<td><i>Works of John Wesley</i>. Edited by Thomas Jackson. 3rd ed. reprint, Peabody: Hendrickson, 1984.</td>
</tr>
<tr>
<td><i>WTJ</i></td>
<td><i>Wesleyan Theological Journal</i></td>
</tr>
<tr>
<td>WUNT</td>
<td>Wissenschaftliche Untersuchungen zum Neuen Testament</td>
</tr>
<tr>
<td><i>ZNW</i></td>
<td><i>Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche</i></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviation.vue?ab4537e2